module.exports = __webpack_public_path__ + "img/hannah-nettuno-kintz.22806122.jpg";